import { Component, forwardRef, Injector, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-r-textarea',
  templateUrl: './r-textarea.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RTextareaComponent),
      multi: true
    }
  ]
})
export class RTextareaComponent extends RenderComponentBase {
  static KEY = 'r-d-textarea';

  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.autosize !== 'string' && typeof config.autosize !== 'boolean') {
      config.autoszie = true;
    }
  }
}
